import { action as apiAction } from 'api/Api'

type Payload = {
  id: number;
  forceRemoval?: boolean;
}

const requestRemoveBlocker = (payload: Payload) => async (dispatch, getState) => {
  const { id, forceRemoval } = payload

  await apiAction('RemoveBlocker', {
    blockerId: id,
    forceRemoval,
  })
}

export default requestRemoveBlocker